import { Component, computed, inject } from '@angular/core';

@Component({
    selector: '[app-footer]',
    standalone: true,
    template: `<div class="layout-footer">
            <div class="footer-logo-container">
                <img src="/layout/images/full-logo.png" alt="poseidon-layout"/>
            </div>
            <span class="footer-copyright">&#169; Happy Mile - USA {{ currentYear }}</span>
        </div>
    `
})
export class AppFooter {
    currentYear: number = new Date().getFullYear();
}
